import Form, { GroupItem, Label, Item } from 'devextreme-react/form'
import React, { useEffect, useState } from "react"
import { useAuth } from "../../contexts/auth"
import LoadPanel from 'devextreme-react/load-panel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './energoobjects.scss'
import {getPoint, getPointPus, getToken, getTokenUk} from '../../api/point.js'
import {notifyIsueAuthFail} from '../../utils/isue-notify'
import notify from "devextreme/ui/notify"
import { getEnergoobject, getGtpFactCodes, getPointsTreePlain } from "../../api/dogovor"
import { useReqPopup } from "../../contexts/req-popup"
import {faBuilding, faGaugeHigh, faLocationDot, faMapLocationDot} from "@fortawesome/free-solid-svg-icons";
import { verifyAccess } from "../../utils/admin.utils"
import AccessDenied from "../../components/access-denied/access-denied"
import {Button} from "devextreme-react/button"
import EnergosferaChart from "../../components/energosfera-chart/energosfera-chart"
import PopupPointsTreeHook from "../../components/points-tree/popup-point-tree-hook"
import EnergosferaChartWithPoints from "../../components/energosfera-chart-with-points/energosfera-chart-with-points";
import EnergosferaChartDog from "../../components/energosfera-chart-dog/energosfera-chart-dog";
import {useScreenSize} from "../../utils/media-query";
import TreeHook from "../../components/points-tree/tree-hook";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import { isPriceCategoryVisible, METER_RKOEFF_LABEL } from "./energoobjects-fields";

const Energoobjects = () => {
    let { isLarge } = useScreenSize();
    const { selectedDog } = useAuth()
    const { openReqPopup, setSelectedTu } = useReqPopup()
    const [selectedObj, setSelectedObj] = useState({})
    const [selectedTu, setSelectedLocalTu] = useState({})
    const [visibleTu, setVisibleTu] = useState(false)
    const [visibleObj, setVisibleObj] = useState(false)
    const [pointPus, setPointPus] = useState({})
    const [loading, setLoading] = useState(false)
    const [loadingVisibleTreeHook, setloadingVisibleTreeHook] = useState(false)
    const [points, setPoints] = useState(null)
    const [visibleEnergosfera, setVisibleEnergosfera] = useState(false)
    const [visibleEnergosferaButton, setVisibleEnergosferaButton] = useState(false)
    const [visibleEnergosferaWithPoints, setVisibleEnergosferaWithPoints] = useState(false)
    const [visibleDogProfile, setVisibleDogProfile] = useState(false)
    const [factCodes, setFactCodes] = useState([])
    const [pointProfile, setPointProfile] = useState(null)
    const pointsType = 'all'
    const [btnProfilDisabled, setBtnProfilDisabled] = useState(true)
    const [selectedPoints, setSelectedPoints] = useState([])
    const [disabledIsue, setDisabledIsue] = useState(true)
    const isuOrIsue = process.env.REACT_APP_NAME_ENV !== 'renergy' ? "Э" : ""
    const onTreeSelect = async (mas) => {
        const el = mas[0]
        setSelectedPoints(mas)
        setDisabledIsue(false)
        if (el && el.isG) { //если объект
            if (+selectedDog.parameter_uk !== 1) setDisabledIsue(true)
            setVisibleObj(true)
            setVisibleTu(false)

            setLoading(true)
            const resObj = await getEnergoobject(el.id)
            if (resObj.isOk) setSelectedObj(resObj.data)
            else notify(resObj.message, 'error', 5000)
            setLoading(false)
            setPointPus({})
        } else if (el && !el.isG) { //если точка
            setBtnProfilDisabled(!el.askue)
            setVisibleTu(true)
            setVisibleObj(false)
            const kodPoint = el.id.split('_')[1]
            if (!kodPoint) return
            setLoading(true)
            const resPoint = await getPoint(kodPoint)
            if (resPoint.isOk) {
                setSelectedTu(resPoint.data.kodPoint)
                setSelectedLocalTu(resPoint.data)
                //достаем прибор учета
                const res = await getPointPus(kodPoint)
                if (res.isOk) {
                    setPointPus(res.data && res.data.kodPointPu ? res.data : null)
                }
                else {
                    notify(res.message, 'error', 5000)
                    setPointPus()
                }
            } else notify(resPoint.message, 'error', 5000)
        } else {
            setVisibleTu(false)
            setVisibleObj(false)
        }
        setLoading(false)
    }

    const onIsue = async () => {
        setLoading(true)
        if (selectedPoints.length > 0) {
            let resToken
            if (+selectedDog.parameter_uk !== 1) {
                if (!selectedPoints[0]?.isG) {
                    resToken = await getToken(selectedPoints[0].id.split('_')[1])
                }
            } else {
                resToken = await getTokenUk(selectedPoints[0].id.split('_')[0])
            }//'885b2c35-8547-4946-8a7d-20c47df8a0c9'
            if (resToken.isOk) {
                let json = resToken.data
                if (json.hasOwnProperty('token')){
                    window.open(json.url + json.token, '_blank');
                } else {
                    notifyIsueAuthFail({message: 'Объект не содержит token'}, 'point')
                }
            } else {
                notifyIsueAuthFail(resToken, 'point')
            }
        } else notify('Не выбран объект', 'error', 3000)
        setLoading(false)
    }

    const [visiblePage, setVisiblePage] = useState(true)

    useEffect(() => {
        const pageRoles = [2]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function () {
            setVisiblePage(true)
            setVisibleTu(false)
            setVisibleObj(false)
            setPoints(null)
            setPointPus(null)
            //получаем точки по договору
            setloadingVisibleTreeHook(true)
            const resPointsTree = await getPointsTreePlain(selectedDog.kodDog, pointsType)
            if (resPointsTree.isOk) {
                setPoints(resPointsTree.data)
                let isEnegosfera = resPointsTree.data.filter(e => e.askue !== 0)
                setVisibleEnergosferaButton(isEnegosfera.length > 0)
            } else {
                notify(resPointsTree.message, 'error', 5000)
            }
            const factRes = await getGtpFactCodes(selectedDog.kodDog)
            if (factRes.isOk) {
                const codes = (factRes.data || []).map((r) => r.code_fact).filter(Boolean)
                setFactCodes(codes)
            } else {
                setFactCodes([])
            }
            setloadingVisibleTreeHook(false)
         })()
    }, [selectedDog])

    function onOpenProfile() {
        if (selectedTu.existAskue){
            setVisibleEnergosfera(true)
            setPointProfile(selectedTu.kodPoint)
        } else {
            notify('Данная точка учета не подключена к сервису online-опроса счетчиков. Для подключения обратитесь к Вашему менеджеру по договору.', 'info', 5000)
        }
    }

    function onOpenProfileWithPoints() {
            setVisibleEnergosferaWithPoints(true)
            setPointProfile(selectedTu.kodPoint)
    }

    const dateOptions = {
        displayFormat: 'dd.MM.yyyy'
    }

    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings big-input' /* d-flex bd-highlight'*/}>
            <div className={'d-flex flex-wrap'}>

            <div className={'flex-grow-1'}>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faMapLocationDot} />
            <h3><strong><ZagolovokFromMenu/></strong></h3>
            </div>
                {factCodes.length > 0 &&
                    <>
                        <Button type={'default'} icon="chart" text={'Суммарный профиль по договору'} hint='Суммарный профиль по договору'
                                style={{marginRight: 8}}
                                onClick={() => setVisibleDogProfile(true)}></Button>
                        <EnergosferaChartDog
                            codes={factCodes}
                            visible={visibleDogProfile}
                            onClosed={() => setVisibleDogProfile(false)}
                            period1={new Date()} period2={new Date()}/>
                    </>
                }
                {visibleEnergosferaButton &&
                    <>
                        <Button type={'default'} icon="chart" text={'Профиль потребления по нескольким ТУ (online)'} hint='Профиль потребления по нескольким ТУ (online)'
                                onClick={() => onOpenProfileWithPoints()}></Button>
                        <EnergosferaChartWithPoints
                            points={points}
                            visible={visibleEnergosferaWithPoints}
                            onClosed={() => {
                                setVisibleEnergosferaWithPoints(false);
                                setPointProfile(null)
                            }}
                            period1={new Date()} period2={new Date()}/>
                    </>
                }
        </div>



            <div className="row mt20">
                {!isLarge ?
                    <div className="col-md-12">
                        <PopupPointsTreeHook
                            points={points}
                            onSelect={onTreeSelect}
                            selectionMode="single"
                            showDisabled={selectedPoints.length === 0}
                        />
                    </div>
                    :
                    <div className="col-lg-3" id='tree-hook'>
                        <LoadPanel position={{ of: '#tree-hook' }} visible={loadingVisibleTreeHook}/>
                        <TreeHook points={points} onSelect={onTreeSelect} selectionMode="single"/>
                    </div>
                }
                <div id='form-container' className={(!isLarge ? "col-md-12" : "col-9") + " mt20lgx tree-hook-left"}>
                    <LoadPanel position={{ of: '#form-container' }} visible={loading}/>
                    {
                        !visibleTu && !visibleObj
                            ?
                            <div className='text-center-horizontal-vertical d-none d-md-block'><strong>Выберите объект энергоснабжения или точку учета</strong></div>
                            :
                            <>
                                {visibleObj?
                                <div>
                                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faBuilding} />
                                    <h4><strong>Объект энергоснабжения:</strong></h4>
                                    <Form colCount={1} labelMode={'floating'} readOnly={true} formData={selectedObj}>
                                        <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="text"><Label text="Номер и наименование ЭО" /></Item>
                                        <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="adr"><Label text="Адрес ЭО" /></Item>
                                        <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="naznhouseName"><Label text="Назначение сооружения" /></Item>
                                        {isPriceCategoryVisible() &&
                                            <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="tarifName"><Label text="Ценовая категория" /></Item>
                                        }
                                        {process.env.REACT_APP_NAME_ENV === 'renergy' &&
                                            <Item dataField="pmaxVol"><Label text="Максимальная мощность объекта, кВт" /></Item>
                                        }
                                        {['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                                            <Item><Button type={'default'} disabled={disabledIsue} className='float-right' text={`Данные ИСУ${isuOrIsue}`} hint="Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУЭ)"
                                                    icon="refresh" onClick={onIsue}/></Item>
                                        }
                                    </Form>
                                </div>:null
                                }

                                {visibleTu?
                                <div className="mb20">
                                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faLocationDot} />
                                    <h4><strong>Точка учета:</strong></h4>
                                    <Form colCount={1} labelMode={'floating'} readOnly={true} formData={selectedTu}>
                                        <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="text"><Label text="Номер и наименование ТУ" /></Item>
                                        <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="namePwrcmp"><Label text="Принадлежность к сетевой компании" /></Item>
                                    </Form>
                                    <div className="row mt20 d-flex justify-content-end">
                                        {['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                                        <div className={'mb-2 col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 isu-point-btn'}>
                                            <Button type={'default'} disabled={disabledIsue} className={'block w-100'} text={`Данные ИСУ${isuOrIsue}`} hint="Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУЭ)"
                                                    icon="refresh" onClick={onIsue}/>
                                        </div>
                                        }
                                        {visibleEnergosferaButton &&
                                        <div className={'mb-2 col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4'}>
                                            <Button type={'default'} disabled={btnProfilDisabled} className='w-100' icon="chart" text="Текущий профиль потребления (online)"  onClick={()=>onOpenProfile()}></Button>
                                            <EnergosferaChart visible={visibleEnergosfera} onClosed={()=> {setVisibleEnergosfera(false); setPointProfile(null)}} point={pointProfile} period1={new Date()} period2={new Date()}/>
                                        </div>
                                        }
                                        <div className={'col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4'}>
                                            <Button type={'default'} className='w-100' icon="edit" text="Редактировать информацию о ТУ"  onClick={()=>{openReqPopup(true,6,null,[],[selectedTu])}}></Button>
                                        </div>
                                    </div>
                                </div>:null}

                                {!selectedPoints[0]?.isG &&
                                <div>
                                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faGaugeHigh} />
                                    <h4><strong>Прибор учета:</strong></h4>
                                    <Form labelMode={'floating'} readOnly={true} formData={pointPus}>
                                            <GroupItem colCount={2} >
                                                <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="numPu"><Label text="Номер" /></Item>
                                                <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="fullname"><Label text="Тип" /></Item>
                                                {/*<Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="tipPu"><Label text="Тип" /></Item>*/}
                                            </GroupItem>
                                            <GroupItem colCount={3}>
                                                <Item dataField="datS" editorType="dxDateBox" editorOptions={dateOptions}><Label text="Дата установки" /></Item>
                                                <Item dataField="dataPo" editorType="dxDateBox" editorOptions={dateOptions}><Label text="Дата снятия" /></Item>
                                                <Item dataField="rkoeff"><Label text={METER_RKOEFF_LABEL} /></Item>
                                            </GroupItem>
                                            <GroupItem colCount={1}>
                                                <Item editorType={'dxTextArea'} editorOptions={{autoResizeEnabled:true, minHeight:35}} dataField="tarifName"><Label text="Тариф" /></Item>
                                            </GroupItem>
                                            <GroupItem colCount={3}>
                                                <Item dataField="voltageName"><Label text="Уровень напряжения" /></Item>
                                                <Item dataField="mpi"><Label text="Межповерочный интервал (лет)"/></Item>
                                                <Item dataField="godPp"><Label text="Год последней поверки" /></Item>
                                                <Item dataField="kvartalPp"><Label text="Квартал последней поверки"/></Item>
                                                <Item dataField="godOp"><Label text="Год очередной поверки"/></Item>
                                                <Item dataField="kvartalPp"><Label text="Квартал очередной поверки"/></Item>
                                            </GroupItem>
                                            <GroupItem colCount={1}>
                                                <Item>
                                                    <div className={'row d-flex justify-content-end'}>
                                                        <div className={'col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4'}>
                                                            <Button type={'default'} className='float-right w-100'
                                                                    disabled={false}
                                                                    text="Сообщить о замене ПУ"
                                                                    hint="Сообщить о замене ПУ"
                                                                    icon="edit"
                                                                    onClick={()=>{openReqPopup(true,5,null,[],[selectedTu],true,pointPus)}}></Button>
                                                        </div>
                                                    </div>
                                                </Item>
                                            </GroupItem>
                                    </Form>
                                </div>
                                }
                            </>
                    }
                </div>
            </div>
        </div>
        : <AccessDenied/>}</>
    )
}

export default Energoobjects
